import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import classnames from 'classnames';
import moment from 'moment';

import CONST from './constants';
import BrzwDatePicker from '../brzw_date_picker';

class FormDateTimePicker extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.toggleTime = this.toggleTime.bind(this);

    this.state = {
      showTime: !!props.time,
      time: props.time || props.defaultTime,
    };
  }

  onChange(datetime) {
    this.props.onChange(datetime);
  }

  onDateChange(value) {
    const { showTime } = this.state;

    const data = {
      date: null,
      time: null,
    };

    if (value) {
      data.date = value.format('YYYY-MM-DD');

      if (showTime) {
        data.time = value.format('HH:mm');
      }
    }

    this.setState(data, this.onChange(data));
  }

  toggleTime() {
    const { date, defaultTime } = this.props;
    const { showTime } = this.state;
    const newShowTime = !showTime;
    const time = showTime ? null : defaultTime;
    this.setState({ showTime: newShowTime, time }, this.onChange({ date, time }));
  }

  render() {
    const {
      className,
      classNameContainer,
      date,
      futureOnly,
      id,
      isClearable,
      label,
      required,
    } = this.props;
    const { showTime, time } = this.state;

    let selected;
    if (date) {
      if (showTime) {
        selected = moment(`${date}T${time}`);
      } else {
        selected = moment(date);
      }
    }

    return (
      <FormGroup row className={classnames('form-group-row', classNameContainer)}>
        <div className="form-group-row__label-container">
          <Label
            for={`${id}-date`}
            className="form-group-row__label form-group-row__label-with-checkbox"
          >
            {required ? (
              <span>
                {label} <span className="text-orange">*</span>
              </span>
            ) : (
              label
            )}
          </Label>
          <div className="time-picker-checkbox">
            <Input
              checked={showTime}
              id={`${id}-checkbox-time`}
              onChange={this.toggleTime}
              type="checkbox"
            />
            <Label
              for={`${id}-checkbox-all`}
              className="form-group-row__label form-group-row__visible-label"
            >
              Add Time
            </Label>
          </div>
        </div>

        <Col className="form-group-row__col">
          <BrzwDatePicker
            futureOnly={futureOnly}
            inputClassName={classnames(className, 'form-control form-group-row__input')}
            isClearable={isClearable}
            onChange={this.onDateChange}
            selected={selected}
            showTimeSelect={showTime}
          />
        </Col>
      </FormGroup>
    );
  }
}

FormDateTimePicker.propTypes = {
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  date: PropTypes.string,
  defaultTime: PropTypes.string,
  futureOnly: PropTypes.bool,
  isClearable: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  time: PropTypes.string,
};

FormDateTimePicker.defaultProps = {
  defaultTime: CONST.DEFAULT_TIME,
  futureOnly: false,
  isClearable: false,
  required: false,
};

export default FormDateTimePicker;
